import { Component, OnInit, Input } from '@angular/core';
import { IContentElement, QuestionState } from '../models';
import { Subject } from 'rxjs';
import { QuestionPubSub } from '../question-runner/pubsub/question-pubsub';
import { LangService } from '../../core/lang.service';

@Component({
  selector: 'element-render-upload',
  templateUrl: './element-render-upload.component.html',
  styleUrls: ['./element-render-upload.component.scss']
})
export class ElementRenderUploadComponent implements OnInit {

  @Input() element:IContentElement;
  @Input() isLocked:boolean;
  @Input() isShowSolution:boolean;
  @Input() questionState:QuestionState;
  @Input() changeCounter:number;
  @Input() questionPubSub?: QuestionPubSub;

  file = {}

  constructor(private lang:LangService) { }

  ngOnInit() {
  }

  getLabel(){
    return this.lang.tra('lbl_upload_response_file');
  }

}
